import type { ReactNode } from "react";
import type { RegistryDatasetRef } from "@/api";
import { truncationMarkerProps } from "@/components/table/truncationCell";
import { openDatasetDetailWindow } from "@/app/datasetDetailWindow";
import { registryDatasetDisplayLabel } from "@/modules/training/public";
import styles from "./RegistryDatasetRefLink.module.css";

// training 데이터셋의 registry 원본 표기. 세션 상세, 평가 결과 표, 정책 표가 함께 쓴다.
// ref 가 있으면 Registry 표시명 링크를 제공한다. ref 가 없으면 상류 이름(있으면)이나
// training-infra 전용 표기를 쓴다. 이 경우 열 상세가 없으므로 링크가 아니라 평문이다.

// registry 원본(공용 Dataset) 상세 창을 연다. ref 가 없는 항목은 이 함수를 호출하지 않고
// training 전용 표기를 쓴다.
export function openRegistryDatasetWindow(ref: RegistryDatasetRef): void {
  openDatasetDetailWindow({ datasetUuid: ref.uuid, displayName: ref.display_name });
}

export type RegistryDatasetRefLinkProps = {
  registryRef?: RegistryDatasetRef | null;
  // 상류 카탈로그 이름. registry 원본이 없을 때 쓰는 2순위 표기다. 서버가 내부 등록 이름을
  // 이미 거른다. 그래서 여기 오는 값은 사람이 읽을 뜻이 있는 이름뿐이다.
  upstreamLabel?: string | null;
  className?: string;
};

export function RegistryDatasetRefLink({
  registryRef,
  upstreamLabel,
  className,
}: RegistryDatasetRefLinkProps): ReactNode {
  // 잘리는 요소와 마커 요소가 같아야 한다. 래퍼에 달면 안쪽 요소가 먼저 잘려 잘림을 감지하지 못한다.
  const truncation = truncationMarkerProps;

  if (!registryRef) {
    return (
      <span className={`${styles.trainingOnly} ${className ?? ""}`} {...truncation}>
        {registryDatasetDisplayLabel(registryRef, upstreamLabel)}
      </span>
    );
  }
  const ref = registryRef;
  return (
    <button
      type="button"
      className={`${styles.link} ${className ?? ""}`}
      onClick={() => openRegistryDatasetWindow(ref)}
      {...truncation}
    >
      {ref.display_name}
    </button>
  );
}
